export const CONFIGURATION = 'CONFIGURATION'
export const SET_CONFIGURATION = 'SET_CONFIGURATION'



// WEBPACK FOOTER //
// ./src/store/modules/configuration/types.js